import { render } from "./OperationsDashboard.vue?vue&type=template&id=8cde55be&scoped=true"
import script from "./OperationsDashboard.vue?vue&type=script&lang=js"
export * from "./OperationsDashboard.vue?vue&type=script&lang=js"

import "./OperationsDashboard.vue?vue&type=style&index=0&id=8cde55be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cde55be"]])

export default __exports__